import { localCliComponentUpdateProjectionSchema, localServiceComponentUpdateProjectionSchema } from "../local-components.js";
import { z } from "zod/v4";
//#region src/schemas/cli/daemon-status-server-requirement.ts
const cliVersionVerdictKindSchema = z.enum([
	"aligned",
	"channel_behind",
	"channel_ahead",
	"channel_unavailable",
	"server_unavailable"
]);
const serviceVersionVerdictKindSchema = z.enum([
	"aligned",
	"update_available",
	"update_required",
	"unknown",
	"server_unavailable"
]);
const cliVersionVerdictSchema = z.strictObject({
	kind: cliVersionVerdictKindSchema,
	message: z.string().trim().min(1)
});
const serviceVersionVerdictSchema = z.strictObject({
	kind: serviceVersionVerdictKindSchema,
	message: z.string().trim().min(1)
});
const daemonStatusServerRequirementUnavailableReasonSchema = z.enum([
	"signed_out",
	"offline",
	"request_failed"
]);
const availableDaemonStatusServerRequirementSchema = z.strictObject({
	available: z.literal(true),
	generatedAt: z.iso.datetime({ offset: true }),
	cli: localCliComponentUpdateProjectionSchema,
	service: localServiceComponentUpdateProjectionSchema,
	verdict: z.strictObject({
		cli: cliVersionVerdictSchema,
		service: serviceVersionVerdictSchema
	})
});
const unavailableDaemonStatusServerRequirementSchema = z.strictObject({
	available: z.literal(false),
	reason: daemonStatusServerRequirementUnavailableReasonSchema,
	detail: z.string().nullable()
});
const daemonStatusServerRequirementSchema = z.discriminatedUnion("available", [availableDaemonStatusServerRequirementSchema, unavailableDaemonStatusServerRequirementSchema]);
//#endregion
export { cliVersionVerdictKindSchema, cliVersionVerdictSchema, daemonStatusServerRequirementSchema, daemonStatusServerRequirementUnavailableReasonSchema, serviceVersionVerdictKindSchema, serviceVersionVerdictSchema };

//# sourceMappingURL=daemon-status-server-requirement.js.map